export default function isValidHttpsUrl(url) {
    const httpsRegex = /^https:\/\//;

    return httpsRegex.test(url);
}
